(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fara-artist-wiki"]) return;
  try {
    
  function prepareFaraWikis() {
    document.querySelectorAll('[data-fara-wiki]').forEach(section => {
      const body = section.querySelector('[data-fara-wiki-body]');
      const contents = section.querySelector('[data-fara-wiki-contents]');
      if (!body || !contents || contents.dataset.prepared) return;
      const headings = body.querySelectorAll('h2');
      const list = contents.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = `FaraWikiHeading-${section.dataset.faraWiki}-${index}`;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      contents.hidden = headings.length === 0;
      contents.dataset.prepared = 'true';
    });
  }
  prepareFaraWikis();
  document.addEventListener('shopify:section:load', prepareFaraWikis);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fara-artists"] && !Shopify.designMode) return;
  try {
    
(() => {
  const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^a-z0-9\u00c0-\uffff]+/g, ' ').trim();
  function mount(section) {
    if (section.dataset.faraDiscoveryReady) return;
    const form = section.querySelector('[data-fara-artists-search]');
    if (!form) return;
    section.dataset.faraDiscoveryReady = 'true';
    const grid = section.querySelector('[data-fara-artists-grid]');
    const input = section.querySelector('[data-fara-artists-query]');
    const submit = section.querySelector('[data-fara-artists-submit]');
    const status = section.querySelector('[data-fara-artists-status]');
    const resetButton = section.querySelector('[data-fara-artists-reset]');
    const moreButton = section.querySelector('[data-fara-artists-more]');
    const noResults = section.querySelector('[data-fara-artists-no-results]');
    const pagination = section.querySelector('[data-fara-artists-pagination]');
    const pageInfo = section.querySelector('[data-fara-artists-page-info]');
    const originalCards = [...grid.children];
    const expected = Number(section.dataset.total);
    const pageLimit = Number(section.dataset.pages);
    const collator = new Intl.Collator(document.documentElement.lang || undefined, { numeric: true, sensitivity: 'base' });
    let index, matches = [], shown = 0, busy = false;
    const describe = card => ({ card, name: card.dataset.faraArtistName || '', key: normalize((card.dataset.faraArtistName || '') + ' ' + (card.dataset.faraArtistGenre || '')) });
    const requestUrl = value => {
      const url = new URL(value, location.href);
      if (url.origin !== location.origin || url.pathname !== location.pathname) throw new Error('Unexpected roster URL');
      url.hash = '';
      url.searchParams.set('section_id', section.dataset.faraArtistsIndex);
      return url.href;
    };
    async function completeIndex() {
      const artists = new Map(originalCards.map(card => [card.dataset.faraArtistHandle, describe(card)]));
      const visited = new Set([requestUrl(location.href)]);
      const queue = [section.dataset.previous, section.dataset.next].filter(Boolean);
      while (queue.length) {
        const url = requestUrl(queue.shift());
        if (visited.has(url)) continue;
        if (visited.size > pageLimit + 1) throw new Error('Roster pagination changed');
        visited.add(url);
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 10000);
        let html;
        try {
          const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Roster request failed');
          html = await response.text();
        } finally { clearTimeout(timeout); }
        // Template contents are inert: no portraits or scripts load while indexing.
        const template = document.createElement('template');
        template.innerHTML = html;
        const next = template.content.querySelector('[data-fara-artists-index]');
        if (!next || next.dataset.faraArtistsIndex !== section.dataset.faraArtistsIndex || Number(next.dataset.total) !== expected) throw new Error('Incomplete roster');
        next.querySelectorAll('[data-fara-artists-grid] > [data-fara-artist-handle]').forEach(card => artists.set(card.dataset.faraArtistHandle, describe(card)));
        [next.dataset.previous, next.dataset.next].filter(Boolean).forEach(link => queue.push(link));
      }
      if (artists.size !== expected) throw new Error('Incomplete roster');
      return [...artists.values()].sort((a, b) => collator.compare(a.name, b.name));
    }
    function showMore() {
      const batch = matches.slice(shown, shown + 48);
      const fragment = document.createDocumentFragment();
      batch.forEach(item => {
        const card = item.card.cloneNode(true);
        card.querySelectorAll('img').forEach(image => { image.loading = 'lazy'; image.setAttribute('fetchpriority', 'auto'); });
        fragment.append(card);
      });
      grid.append(fragment);
      document.dispatchEvent(new Event('fara:preview-prepare'));
      shown += batch.length;
      moreButton.hidden = shown >= matches.length;
      status.textContent = status.dataset.results.replace('__shown__', String(shown)).replace('__total__', String(matches.length));
    }
    function reset() {
      grid.replaceChildren(...originalCards);
      document.dispatchEvent(new Event('fara:preview-prepare'));
      if (pagination) pagination.hidden = false;
      pageInfo.hidden = false;
      noResults.hidden = true;
      moreButton.hidden = true;
      resetButton.hidden = true;
      input.value = '';
      status.textContent = '';
    }
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (busy) return;
      const terms = normalize(input.value).split(' ').filter(Boolean);
      if (!terms.length) { reset(); return; }
      busy = true;
      submit.disabled = true;
      input.readOnly = true;
      form.setAttribute('aria-busy', 'true');
      status.textContent = status.dataset.loading;
      try {
        if (!index) index = await completeIndex();
        if (!section.isConnected) return;
        matches = index.filter(item => terms.every(term => item.key.includes(term)));
        shown = 0;
        grid.replaceChildren();
        if (pagination) pagination.hidden = true;
        pageInfo.hidden = true;
        noResults.hidden = matches.length > 0;
        resetButton.hidden = false;
        showMore();
      } catch {
        if (section.isConnected) status.textContent = status.dataset.error;
      } finally {
        busy = false;
        submit.disabled = false;
        input.readOnly = false;
        form.removeAttribute('aria-busy');
      }
    });
    resetButton.addEventListener('click', () => { if (!busy) { reset(); input.focus(); } });
    moreButton.addEventListener('click', () => {
      const firstNew = grid.children.length;
      showMore();
      if (moreButton.hidden) grid.children[firstNew]?.querySelector('a')?.focus({ preventScroll: true });
    });
    section.querySelector('[data-fara-artists-discovery]').hidden = false;
  }
  const prepare = () => document.querySelectorAll('[data-fara-artists-index]').forEach(mount);
  prepare();
  document.addEventListener('shopify:section:load', prepare);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
